
interface EventChallengeProps {
  challenge: string;
  solution: string;
}

export default function EventChallenge({ challenge, solution }: EventChallengeProps) {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-10">
          <div className="p-8 bg-white rounded-2xl border border-stone-100">
            <div className="w-12 h-12 rounded-xl bg-rose-50 flex items-center justify-center mb-5">
              <i className="ri-lightbulb-line text-xl text-rose-500"></i>
            </div>
            <h3 className="text-xl font-serif font-semibold text-stone-900 mb-4">The Challenge</h3>
            <p className="text-stone-500 leading-relaxed text-sm">{challenge}</p>
          </div>
          <div className="p-8 bg-white rounded-2xl border border-stone-100">
            <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center mb-5">
              <i className="ri-magic-line text-xl text-emerald-600"></i>
            </div>
            <h3 className="text-xl font-serif font-semibold text-stone-900 mb-4">Our Solution</h3>
            <p className="text-stone-500 leading-relaxed text-sm">{solution}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
